export default __webpack_public_path__ + "static/media/switchLine.23daddcd.svg";